import axios from 'axios';
import { constant } from '@app/utils/constant';
import Cookies from 'js-cookie';

export const getUserData = async (filter: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  let params = '?per_page=5000';
  let restype = 'json';
  if (filter.excelExport == true) {
    params += '&export=excel';
    restype = 'arraybuffer';
  }
  try {
    const response = await axios.get(constant.API_BASEPATH + '/users' + params, {
      headers: {
        "Authorization": `Bearer ${BearerToken}`,
      },
      responseType: restype
    });
    return response;
  } catch (err) {
    console.log(err);
  }
};

export const getUserById = async (id: number) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.get(constant.API_BASEPATH + '/users/' + id, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const getPermissionList = async (portal_id: number) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.get(constant.API_BASEPATH + '/users/get-permissions/' + portal_id, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const saveUserData = async (data: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.post(constant.API_BASEPATH + '/users', data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const setUserSiteId = async (id: number, data: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.post(constant.API_BASEPATH + '/users/set-site/' + id, data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const updateUserData = async (id: number, data: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.put(constant.API_BASEPATH + '/users/' + id, data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const deleteUser = async (id: number) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.delete(constant.API_BASEPATH + '/users/' + id, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const updateUserPermissionData = async (id: number, data: any) => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.put(constant.API_BASEPATH + '/users/set-permissions/' + id, data, { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};

export const getUserRoles = async () => {
  const BearerToken = Cookies.get(constant.Cookie_Name);
  try {
    const response = await axios.get(constant.API_BASEPATH + '/users/roles', { headers: { "Authorization": `Bearer ${BearerToken}` } });
    return response;
  } catch (err) {
    console.log(err);
    return { 'data': err.response.data };
  }
};





